import FightersView from '../FightersView.vue'
import FightersRegister from '../layouts/Register.vue'
import FightersUpdate from '../layouts/Update.vue'

export const fightersRoutes = [
  {
    path: '/fighters',
    name: 'fighters',
    component: FightersView,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'view_col'
    }
  },
  {
    path: '/fighters/new',
    name: 'new-fighters',
    component: FightersRegister,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'add_col'
    }
  },
  {
    path: '/fighters/edit/:id',
    name: 'edit-fighters',
    component: FightersUpdate,
    beforeEnter: (to, from, next) => {
      if (!localStorage.__access) next({ name: 'login' })
      next()
    },
    meta: {
      key: 'edit_col'
    }
  }
]
